module.exports = __webpack_public_path__ + "img/W.980d037.jpg";